// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s8-c";
export var backButton = "_s8-4";
export var backIcon = "_s8-5";
export var chevronShortcut = "_s8-6";
export var container = "_s8-1";
export var editor = "_s8-8";
export var editorWrapper = "_s8-7";
export var prefix = "_s8-2";
export var searchIcon = "_s8-3";
export var suffix = "_s8-9";
export var suffixContent = "_s8-a";
export var suffixText = "_s8-b";
export var wrapper = "_s8-0";